import { notifications } from '@bikemap/js/services'

/**
 * Log the current state and copy it as JSON to the clipboard.
 * @param {Object} state
 */
export function debugState(state) {
    // Log a copy of the state
    console.log({ ...state })

    // Copy JSON to clipboard
    const el = document.createElement('textarea')
    el.value = JSON.stringify(state, null, '\t')
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    notifications.show({
        title: 'Copied state to clipboard',
        icon: 'i-copy',
    })
}
